import React from 'react';
import AdminHomeDashboard from './AdminHomeDashboard';

/**
 * Admin portal home — dashboard UI backed by GraphQL APIs.
 */
export default function DashboardSummary({ onQuickAccess }) {
  return <AdminHomeDashboard onQuickAccess={onQuickAccess} />;
}
